import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Action, State, StateContext } from '@ngxs/store';
import { DialogData } from '../../../domain/common.model';
import { ValidationError } from '../../../domain/error.model';
import { DialogComponent } from '../../shared/components/dialog/dialog.component';
import { ContactDataDialogComponent } from '../components/dialog/contact-data-dialog/contact-data-dialog.component';
import { EmailDataDialogComponent } from '../components/dialog/email-data-dialog/email-data-dialog.component';
import { LocationDialogComponent } from '../components/dialog/location-dialog/location-dialog.component';
import { DialogAction } from './dialog.action';

@State({
    name: 'dialog'
})
@Injectable()
export class DialogState {
    dialogRefs = [];

    constructor(private dialog: MatDialog,
                private router: Router,
    ) {
    }

    @Action(DialogAction.CloseAll)
    closeAll() {
        this.dialogRefs.forEach(ref => ref.close());
        this.dialogRefs = [];
    }

    @Action(DialogAction.AddDialogRef)
    addDialogRef(context: StateContext<any>, action: DialogAction.AddDialogRef) {
        this.dialogRefs.push(action.ref);
    }

    @Action(DialogAction.OpenGeneric)
    openGeneric(context: StateContext<any>, action: DialogAction.OpenGeneric) {
        const ref = this.dialog.open(DialogComponent, {
            width: '450px',
            autoFocus: true,
            panelClass: 'dialog-client',
            disableClose: true,
            data: action.data
        });
        context.dispatch(new DialogAction.AddDialogRef(ref));
    }

    @Action(DialogAction.OpenDialogHttpError)
    openError(context: StateContext<any>, action: DialogAction.OpenDialogHttpError) {
        if (action.response.status === 400) {
            const error = new DialogData();
            error.titleLabel = 'LABEL.ERROR';
            error.errors = (action.response.error as ValidationError[]);
            error.hasCancelLabel = false;
            error.confirmLabel = 'BUTTON.OK';
            context.dispatch(new DialogAction.OpenGeneric(error));
        }
    }

    @Action(DialogAction.OpenFailedRouting)
    openFailedRouting(context: StateContext<any>, action: DialogAction.OpenFailedRouting) {
        const data = new DialogData();
        data.titleLabel = 'ERROR.FAILED_ROUTING_HEADER';
        data.descriptionLabel = 'ERROR.FAILED_ROUTING_DESCRIPTION';
        data.descriptionValues = {url: action.url}
        data.hasCancelLabel = false;
        data.confirmLabel = 'BUTTON.OK';
        data.onConfirm = () => {
            this.router.navigate(['/dashboard']);
        };
        const ref = this.dialog.open(DialogComponent, {
            width: '450px',
            autoFocus: true,
            panelClass: 'dialog-routing',
            disableClose: true,
            data
        });
        context.dispatch(new DialogAction.AddDialogRef(ref));
    }

    @Action(DialogAction.OpenContactDataDialog)
    openContactDataDialog(context: StateContext<any>, action: DialogAction.OpenContactDataDialog) {
        const ref = this.dialog.open(ContactDataDialogComponent, {
            width: '690px',
            autoFocus: true,
            panelClass: 'dialog-contact',
            disableClose: true,
            data: {
                calculationId: action.calculationId,
                contactData: action.data,
            }
        });
        context.dispatch(new DialogAction.AddDialogRef(ref));
    }

    @Action(DialogAction.OpenEmailDialogData)
    openEmailDialogData(context: StateContext<any>, action: DialogAction.OpenEmailDialogData) {
        const ref = this.dialog.open(EmailDataDialogComponent, {
            width: '690px',
            autoFocus: true,
            panelClass: 'dialog-contact',
            disableClose: true,
            data: {
                calculationId: action.calculationId,
                emailData: action.data,
            }
        });
        context.dispatch(new DialogAction.AddDialogRef(ref));
    }

    @Action(DialogAction.OpenLocationDialog)
    openLocationDialog(context: StateContext<any>, action: DialogAction.OpenLocationDialog) {
        const ref = this.dialog.open(LocationDialogComponent, {
            width: '690px',
            autoFocus: true,
            panelClass: 'dialog-location',
            disableClose: true,
            data: {
                calculationId: action.offerId,
                location: action.location,
            }
        });
        context.dispatch(new DialogAction.AddDialogRef(ref));
    }
}
